function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { WAREHOUSE_CODES_LABELS } from 'swag-common/interfaces';
export let ORDER_ITEMS_TYPES = /*#__PURE__*/function (ORDER_ITEMS_TYPES) {
  ORDER_ITEMS_TYPES["ALL"] = "ALL";
  ORDER_ITEMS_TYPES["REGULAR"] = "REGULAR";
  ORDER_ITEMS_TYPES["SAMPLE"] = "SAMPLE";
  ORDER_ITEMS_TYPES["BLANK_SAMPLE"] = "BLANK_SAMPLE";
  ORDER_ITEMS_TYPES["PRINTED_SAMPLE"] = "PRINTED_SAMPLE";
  ORDER_ITEMS_TYPES["BOX"] = "BOX";
  ORDER_ITEMS_TYPES["BUNDLE"] = "BUNDLE";
  ORDER_ITEMS_TYPES["INVENTORY"] = "INVENTORY";
  ORDER_ITEMS_TYPES["CUSTOM_STORE"] = "CUSTOM_STORE";
  ORDER_ITEMS_TYPES["DUMMY"] = "DUMMY";
  ORDER_ITEMS_TYPES["REAL"] = "REAL";
  ORDER_ITEMS_TYPES["FIRST_INVENTORY_ORDER"] = "FIRST_INVENTORY_ORDER";
  ORDER_ITEMS_TYPES["REAL_WITHOUT_SAMPLES"] = "REAL_WITHOUT_SAMPLES";
  ORDER_ITEMS_TYPES["GIVEAWAY_NOTECARD"] = "GIVEAWAY_NOTECARD";
  ORDER_ITEMS_TYPES["SUPER_SPEED"] = "SUPER_SPEED";
  ORDER_ITEMS_TYPES["INTERNATIONAL"] = "INTERNATIONAL";
  ORDER_ITEMS_TYPES["EXPIRABLE_PRODUCTS"] = "EXPIRABLE_PRODUCTS";
  ORDER_ITEMS_TYPES["REPLACEMENT"] = "REPLACEMENT";
  ORDER_ITEMS_TYPES["SPLIT_SHIPPED"] = "SPLIT_SHIPPED";
  ORDER_ITEMS_TYPES["UNPAID_ACH_ORDERS"] = "UNPAID_ACH_ORDERS";
  ORDER_ITEMS_TYPES["FORBIDDEN_TO_SHIP_INTERNATIONALLY"] = "FORBIDDEN_TO_SHIP_INTERNATIONALLY";
  return ORDER_ITEMS_TYPES;
}({});
export const COMMON_LABELS = {
  [ORDER_ITEMS_TYPES.ALL]: 'All orders',
  [ORDER_ITEMS_TYPES.REGULAR]: 'Regular ecommerce orders',
  [ORDER_ITEMS_TYPES.BOX]: 'Box orders',
  [ORDER_ITEMS_TYPES.BUNDLE]: 'On demand box orders',
  [ORDER_ITEMS_TYPES.INVENTORY]: 'Inventory orders',
  [ORDER_ITEMS_TYPES.DUMMY]: 'Dummy orders',
  [ORDER_ITEMS_TYPES.REAL]: 'Real orders',
  [ORDER_ITEMS_TYPES.GIVEAWAY_NOTECARD]: 'Giveaway notecard orders',
  [ORDER_ITEMS_TYPES.SUPER_SPEED]: 'Super Speed orders',
  [ORDER_ITEMS_TYPES.INTERNATIONAL]: 'International orders',
  [ORDER_ITEMS_TYPES.EXPIRABLE_PRODUCTS]: 'Expiring products',
  [ORDER_ITEMS_TYPES.REPLACEMENT]: 'Replacement orders',
  [ORDER_ITEMS_TYPES.SPLIT_SHIPPED]: 'Split shipped orders',
  [ORDER_ITEMS_TYPES.UNPAID_ACH_ORDERS]: 'Unpaid ACH/NET orders',
  [ORDER_ITEMS_TYPES.FORBIDDEN_TO_SHIP_INTERNATIONALLY]: 'Orders with restricted item(s)'
};
export const ORDER_ITEMS_TYPES_LABELS = _objectSpread({}, COMMON_LABELS, {
  [ORDER_ITEMS_TYPES.BLANK_SAMPLE]: 'Blank sample orders',
  [ORDER_ITEMS_TYPES.PRINTED_SAMPLE]: 'Printed sample orders',
  [ORDER_ITEMS_TYPES.REAL_WITHOUT_SAMPLES]: 'Real orders without samples'
});
export let ADDITIONAL_ORDERS_FILTER_OPTIONS = /*#__PURE__*/function (ADDITIONAL_ORDERS_FILTER_OPTIONS) {
  ADDITIONAL_ORDERS_FILTER_OPTIONS["MISSING_VERTEX_TRANSACTION"] = "MISSING_VERTEX_TRANSACTION";
  return ADDITIONAL_ORDERS_FILTER_OPTIONS;
}({});
export const ORDER_TYPES_LABELS = _objectSpread({}, COMMON_LABELS, {
  [ORDER_ITEMS_TYPES.SAMPLE]: 'Sample orders',
  [ORDER_ITEMS_TYPES.FIRST_INVENTORY_ORDER]: 'First inventory orders',
  [ADDITIONAL_ORDERS_FILTER_OPTIONS.MISSING_VERTEX_TRANSACTION]: 'Missing Vertex transaction'
});
const STATUSES = {
  CART: 'cart',
  CHECKOUT: 'checkout',
  PAID: 'paid',
  INVENTORY_RECEIVED: 'inventory received',
  PENDING_INVENTORY: 'pending inventory',
  NEED_APPROVAL: 'pending',
  REJECTED: 'rejected',
  SHIPPED: 'shipped',
  FULFILLMENT_CENTER_NOTIFIED: 'fulfillment center notified',
  DELIVERED: 'delivered',
  ORDER_ITEMS_TYPES: ORDER_ITEMS_TYPES,
  VERIFIED: 'verified'
};
const STORE_STATUSES = {
  REJECTED: 'rejected',
  NEED_APPROVAL: 'pending',
  PAID: 'paid',
  FULFILLMENT_CENTER_NOTIFIED: 'fulfillment center notified',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered'
};
const FAILURE_STATUSES = [STATUSES.REJECTED];
export const PSO_STATUSES_LABELS = {
  CREATED: 'Created',
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
  READY_FOR_DISTRIBUTION: 'Ready for distribution',
  CANCELLED: 'Cancelled'
};
export let PRODUCT_SOURCING_STATUSES = /*#__PURE__*/function (PRODUCT_SOURCING_STATUSES) {
  PRODUCT_SOURCING_STATUSES["CREATED"] = "Created";
  PRODUCT_SOURCING_STATUSES["SHIPPED"] = "Shipped";
  PRODUCT_SOURCING_STATUSES["DELIVERED"] = "Delivered";
  PRODUCT_SOURCING_STATUSES["READY_FOR_DISTRIBUTION"] = "Ready for distribution";
  PRODUCT_SOURCING_STATUSES["CANCELLED"] = "Cancelled";
  return PRODUCT_SOURCING_STATUSES;
}({});
export const PRODUCT_SOURCING_STATUSES_LABELS = _objectSpread({
  [ORDER_ITEMS_TYPES.ALL]: 'All statuses'
}, PSO_STATUSES_LABELS);
const PENDING_ORDER_ACTIONS = {
  APPROVE: 'approve',
  REJECT: 'reject'
};
export let TenantFilterOptions = /*#__PURE__*/function (TenantFilterOptions) {
  TenantFilterOptions["POSTAL"] = "postal";
  TenantFilterOptions["SENDOSO"] = "sendoso";
  TenantFilterOptions["SWAG"] = "swag";
  TenantFilterOptions["DYNAMIC"] = "dynamic";
  TenantFilterOptions["\u0421USTOM_INK"] = "custom-ink";
  TenantFilterOptions["ALL"] = "all";
  return TenantFilterOptions;
}({});
export let AbandonedOrderTenantFilterOptions = /*#__PURE__*/function (AbandonedOrderTenantFilterOptions) {
  AbandonedOrderTenantFilterOptions["POSTAL"] = "postal";
  AbandonedOrderTenantFilterOptions["SENDOSO"] = "sendoso";
  AbandonedOrderTenantFilterOptions["SWAG"] = "swag";
  AbandonedOrderTenantFilterOptions["ALL"] = "all";
  return AbandonedOrderTenantFilterOptions;
}({});
export const warehouseOptionAll = 'all';
export const warehouseFilterOptions = _objectSpread({
  [warehouseOptionAll]: 'All warehouses'
}, WAREHOUSE_CODES_LABELS);
export const COMMON_TENANT_LABELS = {
  [TenantFilterOptions.ALL]: 'All sources',
  [TenantFilterOptions.SWAG]: 'Swag',
  [TenantFilterOptions.SENDOSO]: 'Sendoso',
  [TenantFilterOptions.POSTAL]: 'Postal',
  [TenantFilterOptions.DYNAMIC]: 'Swag Space'
};
export const ABANDONED_ORDER_TENANT_LABELS = _objectSpread({}, COMMON_TENANT_LABELS);
export const ORDER_TENANT_LABELS = _objectSpread({}, ABANDONED_ORDER_TENANT_LABELS, {
  [TenantFilterOptions.DYNAMIC]: 'Swag Space',
  [TenantFilterOptions.СUSTOM_INK]: 'Custom Ink'
});
export let TENANT_ORDER_APPROVAL_STATUS = /*#__PURE__*/function (TENANT_ORDER_APPROVAL_STATUS) {
  TENANT_ORDER_APPROVAL_STATUS["PENDING"] = "PENDING";
  TENANT_ORDER_APPROVAL_STATUS["APPROVED"] = "APPROVED";
  TENANT_ORDER_APPROVAL_STATUS["REJECTED"] = "REJECTED";
  return TENANT_ORDER_APPROVAL_STATUS;
}({});
export const FIRST_STAGE_PROJECT = {
  num: 1,
  status: 1,
  orderId: 1,
  adminId: 1,
  inHandDate: 1,
  boxItemsId: 1,
  inventoryId: 1,
  confirmedAt: 1,
  'prod.name': 1,
  'prod.productSettings.productionTimeList': 1,
  prodTime: 1,
  actualTimeline: 1,
  statusUpdatedAt: 1,
  letterIndicator: 1,
  numWithoutPrefix: 1,
  'vendor.attentionName': 1,
  'prod.designUploadMode': 1,
  'expectedByCustomerDates.operationsInHandDate': 1,
  csOwnerId: 1,
  warehouseReceiptUrl: 1,
  customInkOrderId: 1
};
export const SECOND_STAGE_PROJECT = {
  num: 1,
  tenant: 1,
  company: 1,
  priority: 1,
  itemTypes: 1
};
export const FINAL_PROJECT = {
  status: 1,
  prod__name: 1,
  order__num: 1,
  confirmedAt: 1,
  order__tenant: 1,
  adminLastName: 1,
  actualTimeline: 1,
  order__company: 1,
  adminFirstName: 1,
  statusUpdatedAt: 1,
  order__priority: 1,
  vendor__attentionName: 1,
  expectedByCustomerDates__operationsInHandDate: 1,
  csOwnerLastName: 1,
  csOwnerFirstName: 1,
  warehouseReceiptUrl: 1
};
export let DUMMY_ORDER_REASON = /*#__PURE__*/function (DUMMY_ORDER_REASON) {
  DUMMY_ORDER_REASON["CUSTOMER_SOURCED_PRODUCTS"] = "CUSTOMER_SOURCED_PRODUCTS";
  DUMMY_ORDER_REASON["CUSTOMER_ERROR"] = "CUSTOMER_ERROR";
  DUMMY_ORDER_REASON["OTHER"] = "OTHER";
  return DUMMY_ORDER_REASON;
}({});
export const DUMMY_ORDER_REASON_LABELS = {
  [DUMMY_ORDER_REASON.CUSTOMER_SOURCED_PRODUCTS]: 'Customer sourced products',
  [DUMMY_ORDER_REASON.CUSTOMER_ERROR]: 'Customer error during checkout',
  [DUMMY_ORDER_REASON.OTHER]: 'Other'
};
export let INVENTORY_UPSELL_STATUSES = /*#__PURE__*/function (INVENTORY_UPSELL_STATUSES) {
  INVENTORY_UPSELL_STATUSES["INCREASE"] = "INCREASE";
  INVENTORY_UPSELL_STATUSES["APPLIED"] = "APPLIED";
  return INVENTORY_UPSELL_STATUSES;
}({});
export let CUSTOMER_MOCKUP_STATUSES = /*#__PURE__*/function (CUSTOMER_MOCKUP_STATUSES) {
  CUSTOMER_MOCKUP_STATUSES["UPLOADED"] = "uploaded";
  return CUSTOMER_MOCKUP_STATUSES;
}({});
export let PRODUCTION_MOCKUP_STATUSES = /*#__PURE__*/function (PRODUCTION_MOCKUP_STATUSES) {
  PRODUCTION_MOCKUP_STATUSES["UPLOADED"] = "uploaded";
  PRODUCTION_MOCKUP_STATUSES["PENDING_RESELLER_APPROVAL"] = "pending_reseller_approval";
  PRODUCTION_MOCKUP_STATUSES["PENDING_CUSTOMER_APPROVAL"] = "pending_customer_approval";
  PRODUCTION_MOCKUP_STATUSES["APPROVED_BY_CUSTOMER"] = "approved_by_customer";
  PRODUCTION_MOCKUP_STATUSES["DECLINED_BY_RESELLER"] = "declined_by_reseller";
  PRODUCTION_MOCKUP_STATUSES["DECLINED_BY_CUSTOMER"] = "declined_by_customer";
  return PRODUCTION_MOCKUP_STATUSES;
}({});
const ITEM_CLIENT_STATUS_LABEL = {
  REJECTED: 'Rejected',
  PO_SENDED: 'PO sended',
  CANCELLED: 'Cancelled',
  PREPAYMENT_RECEIVED: 'Prepayment received',
  PROCESSING_ORDER: 'Processing order',
  CREATING_PRODUCTION_MOCKUP: 'Creating production mockup',
  REVIEW_COLORS: 'Review colors',
  PENDING_APPROVAL: 'Pending approval',
  VIEW_PRODUCTION_MOCKUP: 'View production mockup',
  IN_PRODUCTION: 'In production',
  REQUESTED_REVISIONS: 'Requested revisions',
  TRACKING_NUMBER: 'Tracking number',
  DELIVERED_TO_WAREHOUSE: 'Delivered to Warehouse',
  READY_FOR_DISTRIBUTION: 'Ready for distribution',
  DELIVERED: 'Delivered'
};
export { STATUSES, FAILURE_STATUSES, PENDING_ORDER_ACTIONS, STORE_STATUSES, ITEM_CLIENT_STATUS_LABEL };